import Sector from "@FreeRider/Track/Sector";
import CanvasPool from '@FreeRider/Utils/CanvasPool';
import PowerupRenderer from '@FreeRider/Renderers/PowerupRenderers/PowerupRenderer';

class SectorRenderer
{
    /*------------------ Config --------------------------------*/

    private static readonly SCENERY_LINE_COLOR = '#AAAAAA';
    private static readonly PHYSICS_LINE_COLOR = '#000000';
    private static readonly LINE_WIDTH = 3;
    private static readonly SECTOR_SIZE = 100;

    /*----------------------------------------------------------*/

    private powerupRenderer: PowerupRenderer;
    private sectorMap: Map<Sector, HTMLCanvasElement>;

    /**
     * Constructor
     */
    constructor()
    {
        this.sectorMap = new Map();
        this.powerupRenderer = new PowerupRenderer();
    }

    /**
     * Renders a sector the a canvas
     * This utilizes a MAP that maps a sector object to a canvas for cache
     * @param sector
     * @param zoom
     */
    public render(sector: Sector, zoom: number): HTMLCanvasElement
    {
        if (this.sectorMap.has(sector))
        {
            return this.sectorMap.get(sector);
        }

        const sectorSize = SectorRenderer.SECTOR_SIZE * zoom;

        const canvas = CanvasPool.get();
        canvas.width = sectorSize;
        canvas.height = sectorSize;

        const canvasCtx = canvas.getContext('2d');

        const physicsLines = sector.physicsLines;
        const sceneryLines = sector.sceneryLines;
        const powerups = sector.powerups;

        const lineWidth = ((SectorRenderer.LINE_WIDTH * zoom) > 0.5) ? (SectorRenderer.LINE_WIDTH * zoom) : 0.5;

        const drawOffsetX = sector.x * SectorRenderer.SECTOR_SIZE;
        const drawOffsetY = sector.y * SectorRenderer.SECTOR_SIZE;

        canvasCtx.clearRect(0, 0, sectorSize, sectorSize);
        canvasCtx.lineWidth = lineWidth;
        canvasCtx.lineCap = 'round';

        canvasCtx.beginPath();
        canvasCtx.strokeStyle = SectorRenderer.SCENERY_LINE_COLOR;

        const sceneryLinesCount = sector.sceneryLines.length;
        for (let i = 0; i < sceneryLinesCount; i++)
        {
            const line = sceneryLines[i];

            const p1x = ((line.p1x - drawOffsetX) * zoom);
            const p1y = ((line.p1y - drawOffsetY) * zoom);
            const p2x = ((line.p2x - drawOffsetX) * zoom);
            const p2y = ((line.p2y - drawOffsetY) * zoom);

            canvasCtx.moveTo(p1x, p1y);
            canvasCtx.lineTo(p2x, p2y);
        }

        canvasCtx.stroke();
        canvasCtx.beginPath();
        canvasCtx.strokeStyle = SectorRenderer.PHYSICS_LINE_COLOR;

        const physicsLinesLength = sector.physicsLines.length;
        for (let i = physicsLinesLength - 1; i >= 0; i--)
        {
            var line = physicsLines[i];

            const p1x = ((line.p1x - drawOffsetX) * zoom);
            const p1y = ((line.p1y - drawOffsetY) * zoom);
            const p2x = ((line.p2x - drawOffsetX) * zoom);
            const p2y = ((line.p2y - drawOffsetY) * zoom);

            canvasCtx.moveTo(p1x, p1y);
            canvasCtx.lineTo(p2x, p2y);
        }

        canvasCtx.stroke();

        // const powerupsCount = powerups.length;
        // for (let i = powerupsCount - 1; i >= 0; i--)
        // {
        //     const powerup = powerups[i];
        //     const powerupX = powerup.x - drawOffsetX;
        //     const powerupY = powerup.y - drawOffsetY;

        //     canvasCtx.beginPath();
        //     canvasCtx.lineWidth = 2;
        //     canvasCtx.strokeStyle = '#000000';
        //     canvasCtx.fillStyle = '#CCCCCC';
        //     canvasCtx.arc(powerupX, powerupY, 5, 0, Math.PI * 2);
        //     canvasCtx.closePath();
        //     canvasCtx.fill();
        //     canvasCtx.stroke();
        // }

        this.sectorMap.set(sector, canvas);

        return canvas;

    }


    /**
     * Frees up a sector
     * @param sector
     */
    public clearCache(sector: Sector): void
    {
        if (this.sectorMap.has(sector))
        {
            const canvas = this.sectorMap.get(sector);

            CanvasPool.free(canvas);

            this.sectorMap.delete(sector);
        }
    }

}

export default SectorRenderer;